import { Navbar, type NavbarTheme } from '@carboncopyco/ui';
import type React from 'react';
import { forwardRef, useMemo, useState } from 'react';
import { EditorNavbarContext } from './EditorNavbarContext';
import { EditorNavbarRecordingTypeIcon } from './EditorNavbarRecordingTypeIcon';
import {
  ChangesTrackerButton,
  ExitButton,
  PreviewButton,
  RedoButton,
  SaveButton,
  UndoButton,
} from './buttons';

export interface EditorNavbarProps {
  children: React.ReactNode;
  theme?: NavbarTheme;
}

const EditorNavbar = forwardRef<HTMLDivElement, EditorNavbarProps>(
  ({ children, theme }, ref) => {
    const [disabledUndoRedo, setDisabledUndoRedo] = useState<boolean>();
    const contextState = useMemo(
      () => ({ disabledUndoRedo, setDisabledUndoRedo }),
      [disabledUndoRedo]
    );

    return (
      <EditorNavbarContext.Provider value={contextState}>
        <Navbar
          ref={ref}
          theme={theme}
        >
          {children}
        </Navbar>
      </EditorNavbarContext.Provider>
    );
  }
) as any;
EditorNavbar.displayName = 'EditorNavbar';

const EditorNavbarNamespace = Object.assign(EditorNavbar, {
  Navigation: Navbar.Navigation,
  Separator: Navbar.Separator,
  ButtonGroup: Navbar.ButtonGroup,
  PageDetails: Navbar.PageDetails,
  SaveButton,
  PreviewButton,
  ExitButton,
  RedoButton,
  UndoButton,
  ChangesTrackerButton,
  RecordingTypeIcon: EditorNavbarRecordingTypeIcon,
});

export { EditorNavbarNamespace as EditorNavbar };
